import { render, staticRenderFns } from "./Expand.vue?vue&type=template&id=dc5c0466&scoped=true&"
import script from "./Expand.vue?vue&type=script&lang=js&"
export * from "./Expand.vue?vue&type=script&lang=js&"
import style0 from "./Expand.vue?vue&type=style&index=0&id=dc5c0466&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc5c0466",
  null
  
)

export default component.exports